import React from "react";

export const ColorCheckIcon = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_9095_14285)">
      <path
        d="M10 17.502C14.1421 17.502 17.5 14.1441 17.5 10.002C17.5 5.85982 14.1421 2.50195 10 2.50195C5.85786 2.50195 2.5 5.85982 2.5 10.002C2.5 14.1441 5.85786 17.502 10 17.502Z"
        fill="black"
        stroke="black"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.875 10.627L8.75 12.502L13.125 8.12695"
        stroke="white"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9095_14285">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.00195312)"
        />
      </clipPath>
    </defs>
  </svg>
);
